export default __webpack_public_path__ + "images/including_baggage.2a5db0c.svg";